import '#src/common/styles/global.css'
import '#lib/events/subscribers'

import App from '#src/common/app'

export default App
